import { fmt, fmtDec } from "../../utils";

/**
 * Helper function to parse lot date (handles Timestamp, string, or Date)
 */
function parseLotDate(dateValue) {
  if (!dateValue) return "-";

  try {
    let dateObj;
    // Firestore Timestamp object
    if (dateValue.seconds) {
      dateObj = new Date(dateValue.seconds * 1000);
    }
    // String date
    else if (typeof dateValue === "string") {
      dateObj = new Date(dateValue);
    }
    // Direct Date object
    else if (dateValue instanceof Date) {
      dateObj = dateValue;
    }

    if (dateObj && !isNaN(dateObj.getTime())) {
      return dateObj.toLocaleDateString("fr-FR");
    }
  } catch (e) {
    console.warn("Error parsing date:", e, dateValue);
  }

  return "-";
}

/**
 * LotCard component - displays individual lot information
 */
export default function LotCard({ lot, index, totalLots, onClick }) {
  const sold = lot.volumeM3_initial ? lot.volumeM3_initial - lot.volumeM3 : 0;
  const isFinished = lot.volumeM3 === 0;
  const today = new Date().toLocaleDateString("fr-FR");
  const purchaseDate = parseLotDate(lot.date);

  // Get K coefficient (handle both 'K' and 'k' field names)
  const kValue = lot.K !== undefined ? lot.K : lot.k;

  return (
    <div
      onClick={onClick}
      style={{
        padding: "12px 14px",
        borderBottom: index < totalLots - 1 ? "1px solid var(--border)" : "none",
        cursor: onClick ? "pointer" : "default",
      }}
    >
      {/* POT/BL Number - format with slashes */}
      <div
        style={{
          fontFamily: "var(--font-mono)",
          fontSize: 12,
          fontWeight: 600,
          color: "var(--text)",
          marginBottom: 4,
        }}
      >
        {lot.numeroPOT || lot.bl || lot.pot || lot.id}
      </div>

      {/* Supplier */}
      {lot.fournisseur && (
        <div
          style={{
            fontSize: 12,
            color: "var(--muted)",
            marginBottom: 8,
          }}
        >
          {lot.fournisseur}
        </div>
      )}

      {/* K coefficient */}
      {kValue !== undefined &&
        kValue !== null &&
        kValue !== 0 &&
        kValue !== "" && (
          <div
            style={{
              fontSize: 11,
              color: "var(--text)",
              marginBottom: 8,
              fontFamily: "var(--font-mono)",
            }}
          >
            K : {typeof kValue === "number" ? fmtDec(kValue, 4) : kValue}
          </div>
        )}

      {/* Purchase date + Initial volume */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "6px 10px",
          background: "var(--bg)",
          borderRadius: 6,
          marginBottom: 4,
        }}
      >
        <div style={{ fontSize: 12 }}>
          <span style={{ color: "var(--text)" }}>{purchaseDate}</span>
        </div>
        <div
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: 13,
            fontWeight: 600,
            color: "var(--text)",
          }}
        >
          {fmt(lot.volumeM3_initial || lot.volumeM3)} m³
        </div>
      </div>

      {/* Current date + Remaining volume */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "6px 10px",
          background: isFinished ? "var(--red-light)" : "var(--bg)",
          borderRadius: 6,
          marginBottom: 4,
        }}
      >
        <div style={{ fontSize: 12 }}>
          <span style={{ color: isFinished ? "var(--red)" : "var(--text)" }}>
            {isFinished ? lot.finishedAt || today : today}
          </span>
        </div>
        <div
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: 13,
            fontWeight: 600,
            color: isFinished ? "var(--red)" : "var(--gold)",
          }}
        >
          {fmt(lot.volumeM3)} m³
        </div>
      </div>
    </div>
  );
}
